export class CookieUtil {
  /**
   * Setzt ein Cookie.
   *
   * @param name Name des Cookies
   * @param value Wert des Cookies
   * @param maxAge Maximalalter des Cookies in Sekunden
   * @param expires Auslaufdatum des Cookies
   */
  public static setCookie(name: string, value: string, maxAge?: number, expires?: Date) {
    let cookieString = `${name}=${value};`;
    cookieString += `path=/;`;

    if (maxAge) {
      cookieString += `max-age=${maxAge};`;
    }

    if (expires) {
      cookieString += `expires=${expires.toUTCString()};`;
    }

    const cookieDomain = this.getCookieDomain();
    if (cookieDomain) {
      cookieString += `domain=${cookieDomain};`;
    }

    cookieString += 'samesite=lax;secure;';
    document.cookie = cookieString;
  }

  /**
   * Gibt den Wert eines Cookies anhand dessen Namen zurück.
   * Existiert kein Cookie zu dem angegebenen Namen wird ein leerer String zurückgegeben.
   *
   * @param name cookieName
   */
  public static getCookieValue(name): string {
    const cookies = document.cookie.split(';');
    const cookie = cookies.find((c) => c.trim().split('=')[0] === name);
    if (!cookie) return '';
    return cookie.split('=')[1];
  }

  private static getCookieDomain() {
    const hostMatcher = window.location.hostname.match(/\.\w+\.\w+$|localhost$/);
    if (hostMatcher) {
      return hostMatcher[0];
    }
    return undefined;
  }
}
